import React from 'react';
import { contactInfo } from '../mock';
import { Instagram, Youtube, Linkedin, Heart } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1a1918] text-white py-12">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="/assets/images/logos/pbg-logo.png" 
                alt="The Photo Booth Guru" 
                className="h-12 w-12 object-contain"
              />
              <div className="text-xl font-bold text-white">The Photo Booth Guru</div>
            </div>
            <p className="text-[#bbb5ae] mb-4 leading-relaxed">
              13+ years of excellence in delivering premium photo booth experiences on rental and now empowering others with our knowledge, experience and products.
            </p>
            <div className="flex items-center space-x-3 mb-2 bg-white px-4 py-3 rounded-lg inline-flex shadow-lg">
              <span className="text-[#1a1918] text-sm font-medium">From the house of</span>
              <img 
                src="/assets/images/logos/inkfly-logo.png" 
                alt="Inkfly" 
                className="h-10 w-auto object-contain"
              />
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#d4af37]">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="#about" className="text-[#bbb5ae] hover:text-[#d4af37] transition-colors">
                  About Us
                </a>
              </li>
              <li>
                <a href="#products" className="text-[#bbb5ae] hover:text-[#d4af37] transition-colors">
                  Products
                </a>
              </li>
              <li>
                <a href="#rentals" className="text-[#bbb5ae] hover:text-[#d4af37] transition-colors">
                  Rentals
                </a>
              </li>
              <li>
                <a href="#gallery" className="text-[#bbb5ae] hover:text-[#d4af37] transition-colors">
                  Gallery
                </a>
              </li>
              <li>
                <a href="#workshops" className="text-[#bbb5ae] hover:text-[#d4af37] transition-colors">
                  Workshops
                </a>
              </li>
              <li>
                <a href="#knowledge" className="text-[#bbb5ae] hover:text-[#d4af37] transition-colors">
                  Knowledge Hub
                </a>
              </li>
              <li>
                <a href="#contact" className="text-[#bbb5ae] hover:text-[#d4af37] transition-colors">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#d4af37]">Contact Us</h3>
            <ul className="space-y-2 text-[#bbb5ae]">
              {contactInfo.phones.map((phone) => (
                <li key={phone}>
                  <a href={`tel:${phone}`} className="hover:text-[#d4af37] transition-colors">
                    {phone}
                  </a>
                </li>
              ))}
              <li>
                <a href={`mailto:${contactInfo.email}`} className="hover:text-[#d4af37] transition-colors break-all">
                  {contactInfo.email}
                </a>
              </li>
            </ul>
            <div className="flex space-x-4 mt-6">
              <a
                href={contactInfo.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#d4af37] p-2 rounded-lg hover:bg-[#ffd700] transition-colors"
              >
                <Instagram className="w-5 h-5 text-[#1a1918]" />
              </a>
              <a
                href={contactInfo.social.youtube}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#d4af37] p-2 rounded-lg hover:bg-[#ffd700] transition-colors"
              >
                <Youtube className="w-5 h-5 text-[#1a1918]" />
              </a>
              <a
                href={contactInfo.social.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#d4af37] p-2 rounded-lg hover:bg-[#ffd700] transition-colors"
              >
                <Linkedin className="w-5 h-5 text-[#1a1918]" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#736c64] pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-[#bbb5ae] text-sm">
              © {new Date().getFullYear()} Photo Booth Guru. All rights reserved.
            </p>
            <p className="text-[#bbb5ae] text-sm flex items-center space-x-2">
              <span>Made with</span>
              <Heart className="w-4 h-4 text-[#d4af37] fill-current" />
              <span>in India</span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;